"use client";
import type { ApolloError } from "@apollo/client";

import {
  ClientErrors,
  GeneralError,
  GraphqlErrors,
  NetworkError,
} from "@/components/model";

export default function ErrorPage({
  error,
  reset,
}: {
  error: ApolloError;
  reset: () => void;
}) {
  if (error.graphQLErrors) {
    return <GraphqlErrors graphQLErrors={error.graphQLErrors} reset={reset} />;
  }
  if (error.clientErrors) {
    return <ClientErrors clientErrors={error.clientErrors} />;
  }
  if (error.networkError) {
    return <NetworkError networkError={error.networkError} />;
  }
  return <GeneralError error={error} />;
}
